import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material'
import React from 'react'
import { TEXT_TITLE_COLOR } from '../../../constants/colors'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { BOX_SHADOW_STYLE } from '../../../constants/boxShadow';

interface Props {
    onClose: VoidFunction
}

const RegisterMerchantForm = ({ onClose }: Props) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ boxShadow: BOX_SHADOW_STYLE, width: '1000px', borderRadius: '1rem' }}>
                <IconButton onClick={onClose} >
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Typography variant='h4' fontWeight="bold" color={TEXT_TITLE_COLOR} textAlign='center'>Register Merchant</Typography>
                <Grid container mt={2} sx={{ p: 2 }}>
                    <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>Merchant Name</Typography>
                        <TextField
                            size='small'
                            margin='normal'
                            sx={{
                                width: '60%',
                                background: "var(--transparent-grey-8, rgba(145, 158, 171, 0.08))",
                                border: 'none',
                                borderRadius: 3,
                                "& fieldset": { borderRadius: 3 },
                            }}
                        />

                    </Grid>
                    <Grid item xs={12} sm={6} md={6} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>Product Category</Typography>
                        <TextField size='small' style={{ width: '60%' }} margin='normal' type='file' />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>Sample product image</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', cursor: 'pointer', gap: 2, mt: 1, mb: 1 }} >
                            <img style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                            <Box>
                                <Typography fontWeight="bold" fontSize={20}>Select files</Typography>
                                <Typography color="grey">Drop files here or click browse through you machine </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>Business certificate</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', cursor: 'pointer', gap: 2, mt: 1, mb: 1 }} >
                            <img style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                            <Box>
                                <Typography fontWeight="bold" fontSize={20}>Select files</Typography>
                                <Typography color="grey">Drop files here or click browse through you machine </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>Shop location (Google Map Link)</Typography>
                        <TextField
                            size='small'
                            margin='normal'
                            sx={{
                                width: '60%',
                                background: "var(--transparent-grey-8, rgba(145, 158, 171, 0.08))",
                                border: 'none',
                                borderRadius: 3,
                                "& fieldset": { borderRadius: 3 },
                            }}
                        />
                    </Grid>
                </Grid>
                <Box m={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant='contained' color='error' sx={{ textTransform: 'none', color: '#fff', mr: 1 }} onClick={onClose}>Cancel</Button>
                    <Button variant='contained' color='secondary' sx={{ textTransform: 'none', color: '#fff' }}>Submit</Button>
                </Box>
            </Box>
        </Box >
    )
}

export default RegisterMerchantForm